'use strict';
import Barba from 'barba.js'
import Env from '../base/env.js'
import Channels from '../base/channels'
import TypeWriter from '../components/about/TypeWriter'
// import Marquee from '../components/about/MarqueeInfinite'
import Marquee2D from '../components/about/MarqueeInfinite2D'
import Solitaire from '../components/about/Solitaire'
// import Snake  from '../components/about/Snake'
import FlowWaypoints from '../components/FlowWaypoints'
import raf from 'raf'

import 'babel-polyfill'

let page

class Page
{
    constructor(view='')
    {
        this.view = view
        this.catchphrases = this.view.querySelector('.jsData').value.split('[=]')
        this.$solitaire = this.view.querySelector('.jsSolitaire')
        this.$triggerSolitaire = this.view.querySelector('.jsSolitaire-trigger')
        this.classView = 'currentView--about'
        // States
        this.solitaireStarter = (Env.mobileCSS === true)?true:false
        // Flags
        this.SOLITAIRE_LAUNCH = false
        // Fns
        // this.marquee = new Marquee(this.view)
        this.marquee = new Marquee2D(this.view)
        this.solitaire = new Solitaire({
            viewport: document.querySelector('.jsSolitaire'),
            path: config.pathAssets+'/img/',
            images: [
                'file.png'
            ],
            n: 1,
            positionMobile: this.solitaireStarter,
            resize: true
        });
        // Launch Fn
        this.funcLaunch = this.intro.bind(this)
        if(Env.framework.UI.launcher.LAUNCHED == false) this.channels()
    }

    channels()
    {
        Channels.on('launcher::exit',this.funcLaunch)
    }

    destroy()
    {
        Channels.removeListener('launcher::exit', this.funcLaunch);
        raf.cancel(this.raf)
        this.marquee.destroy()
        this.waypoints.destroy()
    }


    finalize()
    {
        setTimeout(() => {
            this.marquee.setup()
        }, 200);
        this.solitaire.load();
        this.$triggerSolitaire.addEventListener('click',()=>{
            if(this.SOLITAIRE_LAUNCH === false) {
                this.solitaire.start();
                this.SOLITAIRE_LAUNCH = true
                this.$solitaire.classList.add('is--active')
                this.$triggerSolitaire.classList.add('is--disabled')
            }
        })
        this.typewriter = new TypeWriter(this.view,this.catchphrases)
        this.watcher()
        this.waypoints = new FlowWaypoints(this.view)
        setTimeout(() => {
            if(Env.isVisiting === true) {
                this.intro()
            }
        }, 100);
    }

    intro()
    {
        let timeline = new TimelineLite()
        const $fill = this.view.querySelector('.fxFill')
        const $brand = this.view.querySelector('.fxBrand')
        const $prez = this.view.querySelector('.fxPrez')

        timeline.add([
            TweenLite.fromTo($fill , 1 , { scaleX : 0 } , { scaleX : 1 , ease : Power3.easeInOut }),
            TweenLite.fromTo($brand , 1 , { opacity : 0 , y : 100 } , { opacity : 1 , y : 0 , delay : .3 , ease : Power3.easeOut }),
            TweenLite.fromTo($prez.querySelector('.h6') , 1 , { opacity : 0 , y : 30 } , { opacity : 1 , y : 0 , delay : .5 , ease : Power3.easeOut }),
            TweenLite.fromTo($prez.querySelector('.description') , 1 , { opacity : 0 , y : 30 } , { opacity : 1 , y : 0 , delay : .6 , ease : Power3.easeOut }),
        ])
        timeline.add(()=>{
            this.typewriter.animation()
        })
    }

    watcher()
    {
        this.raf = raf(()=>{
            this.watcher()
        })
    }

}

page = Barba.BaseView.extend({
    namespace: 'about',
    node: undefined,
    onEnter: function() {
        this.node = new Page(this.container)
        Env.$html.classList.add(this.node.classView)
    },
    onLeave: function()
    {
        this.node.destroy()
    },
    onEnterCompleted:function() {
        this.node.finalize()
    },
    onLeaveCompleted: function()
    {
        if(this.container.getAttribute('data-namespace') != this.namespace)
        {
            Env.$html.classList.remove(this.node.classView)
        }
    }
});

export default page;